import type { TFunction } from 'i18next';
import type { ConfigObject } from '../../_configs/types';
import type { Facets, Filter } from '../../_types/Car';
import type { Translations } from '../../locales/translations';
import checkUndefinedNullOrEmpty from '../tools/checkUndefinedNullOrEmpty';
import uniqueArray from '../tools/uniqueArray';

export default function getSearchHeading(translate: TFunction, allFacets: Facets, filter: Filter, settings: ConfigObject): { withPage: string; withoutPage: string } {
    const returnArrayWithoutPage = [];
    const locationFacetKey = settings?.general?.useFirmenFilter ? 'firmenAll' : 'standortAll';
    const locationFilterKey = settings?.general?.useFirmenFilter ? 'idFirma' : 'Standort';
    // only add hersteller to heading if no model filter; model already includes hersteller name, otherwise "Audi Audi A6"
    if (!checkUndefinedNullOrEmpty(filter?.hersteller0) && filter?.hersteller0 > -1 && filter?.modell0 <= -1) {
        const hs = allFacets?.herstellerAll?.find((f) => f?.i === filter?.hersteller0)?.t;
        returnArrayWithoutPage.push(hs);

        // if no type filter like "used cars", add "cars" for better SEO
        if (checkUndefinedNullOrEmpty(filter?.akttypList)) {
            returnArrayWithoutPage.push(translate('common:buttons.vehicles'));
        }
    }
    if (!checkUndefinedNullOrEmpty(filter?.modell0) && filter?.modell0 > -1) {
        const md = allFacets?.modellAll?.find((f) => f?.i === filter?.modell0)?.t;
        returnArrayWithoutPage.push(md);
    }
    if (!checkUndefinedNullOrEmpty(filter?.tags) && filter?.tags !== '-100') {
        const tag = allFacets?.tagsAll?.find((f) => f?.i === filter?.tags)?.t;
        returnArrayWithoutPage.push(tag);
    } else if (!checkUndefinedNullOrEmpty(filter?.akttypList)) {
        const typArr = [];
        let typLast = '';
        const newFilterArray = uniqueArray(filter?.akttypList?.map((val) => (val > 0 && val !== 1 ? 2 : val)))?.sort();
        newFilterArray?.map(function (t, i) {
            const typ: string = translate(`common:car.types.plural.${t?.toString() as keyof Translations['car']['types']['plural']}`);
            if (i !== newFilterArray?.length - 1) {
                typArr.push(typ.replace('wagen', '-'));
            } else {
                typLast = typ;
            }
        });
        if (typArr.length > 0) {
            returnArrayWithoutPage.push([typArr.join(', '), typLast].join(` ${translate('common:common.and')} `));
        } else {
            returnArrayWithoutPage.push(typLast);
        }
    }

    if (returnArrayWithoutPage.length === 0) {
        returnArrayWithoutPage.push(translate('common:carSearch.heading'));
    }

    // end with customer name or locations for SEO
    if (!checkUndefinedNullOrEmpty(filter?.[locationFilterKey])) {
        const loc = [];
        filter?.[locationFilterKey]?.map((val) => {
            const location = allFacets?.[locationFacetKey]?.find((f) => f?.i === val)?.sd;
            loc.push(location?.ort);
        });
        returnArrayWithoutPage.push(`${translate('common:common.in')} ${uniqueArray(loc)?.join(', ')}`);
    } else {
        returnArrayWithoutPage.push(`${translate('common:common.at')} ${settings?.general?.projectName}`);
    }

    return {
        withoutPage: returnArrayWithoutPage?.join(' '),
        withPage: [...returnArrayWithoutPage, !checkUndefinedNullOrEmpty(filter?.moreCars) && filter?.moreCars > 1 ? ` - ${translate('common:carSearch.page')} ${filter?.moreCars}` : undefined]
            ?.filter((e) => !checkUndefinedNullOrEmpty(e))
            ?.join(' '),
    };
}
